import {Container} from 'pixi.js';
import {Emitter} from '@pixi/particle-emitter';
import {Updatable} from '@gongxigames/framework/core/fragments/update/Updatable';

/**
 * Particle emitter controller v5
 */

export class EmitterV5 extends Updatable {
    private needUpdate = false;
    private _baseEmitter: any = false;

    constructor(particleParent: Container, config: any) {
        super(true);
        this.initParticles(particleParent, config);
    }

    public update(dt: number): void {
        if (this.needUpdate) {
            let delta = 16;

            if (dt >= 0) {
                delta = Math.round(dt);
            }

            // NOTE: number of seconds since the last update
            this._baseEmitter.update(delta * 0.001);
        }
    }

    private initParticles(container: any, config: any): void {
        const pc = new Container();

        this._baseEmitter = new Emitter(pc, config);
        container.addChild(pc);
    }

    public startEmit(): void {
        if (this._baseEmitter) {
            this._baseEmitter.emit = true;
            this.needUpdate = true;
        } else {
            console.warn('Emitter not found');
        }
    }

    // NOTE: soft stop, continue showing limited by lifetime prop
    public stopEmit(): void {
        this._baseEmitter.emit = false;
    }

    // NOTE: hard stop
    public stopEmitAndCleanup(): void {
        this._baseEmitter.emit = false;
        this.needUpdate = false;
        this._baseEmitter.autoUpdate = false;
        this._baseEmitter.cleanup();
    }

    public get baseEmitter(): Emitter {
        return this._baseEmitter;
    }
}